<template>
  <div id="app">
    <div class="logo"></div>
    <div class="content">
      <div v-if="!submitSuccess">
        <!-- logo -->
        <!-- 请选择问题的业务类型 -->
        <div class="business-list">
          <div class="title">请选择问题的业务类型</div>
          <div class="kfc-business-type-list-line">
            <div v-if="businessTypeLineArr.length > 0">
              <div
                v-for="(businessTypeLine, index) in businessTypeLineArr"
                :key="index"
                class="kfc-business-type-list-line"
              >
                <div
                  v-for="(businessType, innerIndex) in businessTypeLine"
                  :key="innerIndex"
                  class="kfc-business-type-list-line-item"
                  :class="[
                    `${businessType.businessType}` ===
                      `${currentBusinessType}` &&
                    `${innerIndex}` === `${currentIndex}`
                      ? 'isSelected kfc-active-border'
                      : '',
                  ]"
                  @click="$_handleBusinessTypeSelect(businessType, innerIndex)"
                >
                  <span
                    v-if="
                      `${businessType.businessType}` ===
                        `${currentBusinessType}` &&
                      `${innerIndex}` === `${currentIndex}`
                    "
                    class="iconfont icon-checked-mark kfc-business-type-list-line-item-sign kfc-theme-color"
                  ></span>
                  <img
                    :src="businessType.icon"
                    class="kfc-business-type-list-line-item-icon"
                  />
                  <div class="kfc-business-type-list-line-item-text">
                    {{ businessType.businessTypeName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 请描述您遇到的问题情况 -->
        <div class="describe-problem">
          <div class="title">请描述您遇到的问题情况</div>
          <div class="kfss-textarea">
            <textarea
              v-model="problemText"
              class="kfss-textarea__inner"
              placeholder="请您至少输入8个字（必填）"
            >
            </textarea>
            <div
              class="error_toast"
              v-if="problemText.trim().length < minLength && problemText.length"
            >
              最少输入{{ minLength }}个中文字符
            </div>
          </div>
        </div>
        <!-- 补充上传有效的图片等材料，帮助我们更快处理问题 -->
        <div class="supplementary-images">
          <div class="title">
            补充上传有效的图片等材料，帮助我们更快处理问题
          </div>
          <div class="kfss-img-uploader">
            <ul class="kfss-img-list">
              <li
                class="kfss-img-wrapper"
                v-for="(imgObj, i) in imgObjList"
                :key="i"
              >
                <img
                  class="kfss-img"
                  :src="imgObj.dataUrl"
                  @click="$_onImgClick(i)"
                />
                <div class="kfss-delete" @click="$_onImgRemoveClick(i)">
                  <md-icon class="kfss-delete-btn" name="close" />
                </div>
                <span
                  v-if="imgObj.status !== IMG_STATUS.SUCCESS"
                  class="kfss-upload-status"
                >
                  <md-icon
                    v-if="imgObj.status === IMG_STATUS.UPLOADING"
                    class="kfss-upload-status-loading"
                    name="spinner"
                  ></md-icon>
                  <div
                    v-if="imgObj.status === IMG_STATUS.ERROR"
                    class="kfss-upload-status-error"
                  >
                    <md-icon name="warn" size="xs"></md-icon>
                    <span class="kfss-upload-status-error-content">{{
                      IMG_STATUS_TEXT.ERROR
                    }}</span>
                  </div>
                </span>
              </li>
              <li
                v-show="imgObjList.length < max"
                class="kfss-img-wrapper kfss-img-upload-btn"
              >
                <img
                  class="kfss-add-btn"
                  src="//img-ys011.didistatic.com/static/kfss_components/upload%402x.png"
                />
                <md-image-reader
                  name="image-reader"
                  @select="$_onReaderSelect"
                  @complete="$_onReaderComplete"
                  @error="$_onReaderError"
                />
              </li>
            </ul>
            <md-image-viewer
              v-model="isShowViewer"
              :list="viewerImgSrcList"
              :initial-index="viewerIndex"
            />
          </div>
        </div>
        <!-- 补充您的有效联系方式 -->
        <div class="supplementary-link">
          <div class="title">补充您的有效联系方式</div>
          <div class="input">
            <md-input-item
              v-model="phoneNumber"
              class="input__inner"
              placeholder="仅用于更快与您取得联系（非必填）"
              type="phone"
            />
          </div>
        </div>
        <!-- 提交 -->
        <button
          :class="isButtonDisable && 'button-disabled'"
          class="submit-button"
          @click="$_submit"
        >
          提交
        </button>
      </div>

      <div class="submit-result" v-else>
        <div class="md-success" v-if="submitSuccess">
          <md-icon name="success" :svg="false"></md-icon>
          <p class="success-tip">
            提交成功，我们将在5个工作日内与您联系并反馈处理结果！
          </p>
        </div>
        <div class="md-fail" v-else>
          <md-icon name="fail" :svg="false"></md-icon>
          <p class="fail-tip">提交失败，请稍后再试！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import service from "./service";
import { statusMap } from "@/config/api";
import {
  Dialog,
  Icon,
  ImageReader,
  ImageViewer,
  Toast,
  InputItem,
} from "mand-mobile";
import {
  UPLOAD_CODE,
  IMG_STATUS_TEXT,
  IMG_STATUS,
  businessTypeConfigList,
} from "./config";

export default {
  name: "App",
  components: {
    [Dialog.name]: Dialog,
    [Icon.name]: Icon,
    [ImageReader.name]: ImageReader,
    [ImageViewer.name]: ImageViewer,
    [InputItem.name]: InputItem,
  },
  data() {
    return {
      businessTypeLineArr: _.chunk(businessTypeConfigList, 5),
      problemText: "",
      currentBusinessType: "", // 业务线
      currentIndex: null,
      minLength: 8, // 最小输入长度
      IMG_STATUS,
      IMG_STATUS_TEXT,
      imgObjList: [],
      isShowViewer: false,
      viewerIndex: 0,
      max: 9, // 最大上传文件数
      phoneNumber: null, // 电话号码
      roleType: null, // 用户类型
      dictId: "", // 工单标题
      submitSuccess: false,
    };
  },
  computed: {
    uploadSuccessImgList() {
      return _.filter(this.$data.imgObjList, { status: IMG_STATUS.SUCCESS });
    },
    viewerImgSrcList() {
      return this.$data.imgObjList.map((item) => item.dataUrl);
    },
    isButtonDisable() {
      const { dictId, roleType, problemText } = this;
      return !dictId || !roleType || !problemText.length;
    },
  },
  methods: {
    $_handleBusinessTypeSelect(businessTypeConfigItem, innerIndex) {
      this.$data.currentIndex = innerIndex;
      this.$data.currentBusinessType = businessTypeConfigItem.businessType;
      const roleArr = businessTypeConfigItem.roleInfoList;
      if (businessTypeConfigItem.roleInfoList.length > 1) {
        // 分多个角色
        Dialog.confirm({
          title: "请选择您的用户身份",
          cancelText: roleArr[0].role_name,
          confirmText: roleArr[1].role_name,
          transform: "md-zoom",
          onConfirm: () => {
            this.$data.roleType = roleArr[1].role_type; // 角色身份
            this.$data.dictId = roleArr[1].dictId; // 工单标题id
          },
          onCancel: () => {
            this.$data.roleType = roleArr[0].role_type; // 角色身份
            this.$data.dictId = roleArr[0].dictId; // 工单标题id
          },
        });
      } else {
        // 只存在单一角色
        this.$data.roleType = roleArr[0].role_type; // 角色身份
        this.$data.dictId = roleArr[0].dictId; // 工单标题id
      }
    },
    $_onImgClick(i) {
      this.$data.isShowViewer = true;
      this.$data.viewerIndex = i;
    },
    // 图片选择完成事件
    $_onReaderSelect(name, { files }) {
      console.log("[kfss-img-uploader $_onReaderSelect]: ", name, { files });
    },
    // 图片读取完成事件
    $_onReaderComplete(name, { dataUrl, file }) {
      console.log("[kfss-img-uploader $_onReaderComplete]: ", name, {
        dataUrl,
        file,
      });

      if (file.size > 10 * 1024 * 1024) {
        Toast.info(`超出图片大小限制10M`);
        return;
      }

      // 拍照上传时
      // OPPO R9S: file.name为xxx.bin, file.type为application/octet-stream
      // iPhoneX: file.name为image.jpg, file.type为image/jpeg
      // 相册上传时
      // OPPO R9S: file.name为xxx.jpg, file.type为image/jpeg
      // iPhoneX: file.name为xxx.png, file.type为image/png
      if (!/(jpe?g|jpeg|png|gif|bmp|bin)$/i.test(file.name)) {
        Toast.info("不支持的图片格式");
        return;
      }

      const timestamp = Date.now(); // 作为图片的唯一标识，用于精准更新状态，index会受删除图片影响

      this.$_addUploadingImg(dataUrl, timestamp, file);
      this.$_uploadImg(dataUrl, timestamp);
    },
    $_onReaderError(name, { code, msg }) {
      console.log("[kfss-img-uploader $_onReaderError]: ", name, { code, msg });
    },
    // 删除图片
    $_onImgRemoveClick(index) {
      console.log("[kfss-img-uploader $_onImgRemoveClick]: ", index);
      this.$data.imgObjList.splice(index, 1);
    },
    $_addUploadingImg(dataUrl, timestamp, file) {
      const fileDate = new Date(file.lastModified);
      const fileName =
        `${fileDate.getMonth() + 1}月${fileDate.getDate()}日` +
        (Math.floor(Math.random() * 90000) + 10000);
      this.$data.imgObjList.push({
        name: fileName,
        dataUrl,
        status: IMG_STATUS.UPLOADING,
        timestamp,
      });
    },
    $_uploadImg(dataUrl, timestamp) {
      service
        .upload(dataUrl)
        .then(({ error, data }) => {
          const { code, path, randomCode } = _.get(data, "data");
          if (error || code === UPLOAD_CODE.INVALID || !path) {
            this.$_updateImgList({
              timestamp,
              status: IMG_STATUS.ERROR,
            });
            return;
          }
          this.$_updateImgList({
            timestamp,
            status: IMG_STATUS.SUCCESS,
            cdnUrl: path,
            randomCode: randomCode,
          });
        })
        .catch(() => {
          this.$_updateImgList({
            timestamp,
            status: IMG_STATUS.ERROR,
          });
          return;
        });
    },
    $_updateImgList({ timestamp, status, cdnUrl = "", randomCode = "" }) {
      this.$data.imgObjList.map((imgObj) => {
        if (imgObj.timestamp === timestamp) {
          _.extend(imgObj, { status, cdnUrl, randomCode });
        }
      });
    },
    async $_submit() {
      const {
        roleType,
        currentBusinessType,
        dictId,
        problemText,
        uploadSuccessImgList,
        phoneNumber,
        isButtonDisable,
      } = this; // 用户身份、用户类型、工单id
      if (isButtonDisable) return;

      const attachmentsList = _.map(uploadSuccessImgList, (item) => {
        return {
          name: item.name,
          url: item.cdnUrl,
          randomCode: item.randomCode,
        };
      });

      const params = {
        businessType: currentBusinessType,
        roleType: roleType,
        dictId: dictId,
        channel: 270,
        wfrole: "customer_service",
        content: `${problemText}${
          phoneNumber ? `，用户补充联系方式：${phoneNumber}` : ""
        }`,
        attachments: attachmentsList,
      };

      if (phoneNumber && !/^1[3456789]\d{9}$/.test(phoneNumber)) {
        Toast.info("手机号不合法，请重新填写！");
        this.$data.phoneNumber = null;
        return;
      }
      if (!currentBusinessType) {
        Toast.info("请选择业务类型！");
        return;
      }
      if (!problemText.length) {
        Toast.info("问题情况为必填项！");
        return;
      }
      if (problemText.length < this.minLength) {
        Toast.info("问题情况部分请您至少输入8个字！");
        return;
      }
      Toast.loading("提交中");

      const { data } = await service.createWorksheet(params);

      Toast.hide();
      if (data.status == statusMap.SUCCESS) {
        this.$data.submitSuccess = true;
        return;
      }
      this.$data.submitSuccess = false;
    },
  },
};
</script>

<style lang="less">
@font-face {
  font-family: "iconfont"; /* Project id  */
  src: url("//img-ys011.didistatic.com/static/kefu_center/iconfont-kfc-usage-feedback.ttf?t=1651910027326")
    format("truetype");
}

body {
  .md-dialog-title,
  .md-dialog-btn {
    font-size: 34px;
  }
  .md-dialog-btn:active {
    background: #666f83 !important;
  }

  .md-dialog-btn:last-child {
    color: #666f83 !important;
  }
  .md-toast-text {
    white-space: break-spaces;
  }
}

#app {
  .logo {
    width: 100%;
    height: 84px;
    background: center/100% 100% no-repeat;
    background-image: url("http://img-ys011.didistatic.com/static/kefu_center/do1_FM9rx9RFankXpYJbKtMi");
  }
}

.content {
  background: #fff;
  padding: 32px;
  box-sizing: border-box;
  position: relative;
  .submit-result {
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    .md-success,
    .md-fail {
      position: absolute;
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      top: 200px;
      .md-icon-success,
      .md-icon-fail {
        color: #fc9153;
        font-size: 100px;
      }
      .success-tip,
      .fail-tip {
        text-align: center;
        margin-top: 20px;
        font-size: 30px;
        width: 500px;
      }
    }
  }
  .title {
    font-size: 28px;
    color: #222222;
    font-weight: 600;
    padding-bottom: 15px;
  }
  .business-list,
  .describe-problem,
  .supplementary-images {
    border-bottom: 1px solid #ece9e9;
    margin-bottom: 40px;
  }

  .kfc-business-type-list-line {
    display: flex;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 2px 0;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
  .kfc-business-type-list-line-item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 131px;
    height: 131px;
    padding: 18px 0;
    border: 1px solid #fff;
    background: #fff;
    border-radius: 12px;
    margin-right: 8px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
  }

  .kfc-business-type-list-line-item.isSelected {
    background: #fef7f3;
  }
  .kfc-active-border {
    border-color: #fc9153;
  }
  .kfc-business-type-list-line-item-sign {
    position: absolute;
    top: 0px;
    right: -1px;
    border-top-right-radius: 10px;
    font-size: 40px;
    line-height: 40px;
    overflow: hidden;
  }
  .kfc-business-type-list-line-item-icon {
    width: 60px;
    height: 60px;
    vertical-align: bottom;
    margin-bottom: 10px;
  }

  .kfc-business-type-list-line-item-text {
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: #444444;
    text-align: center;
    line-height: 24px;
  }

  .iconfont {
    font-family: "iconfont" !important;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-checked-mark:before {
    content: "\e612";
  }
  .kfc-theme-color {
    color: #fc9153;
  }

  .kfss-textarea {
    box-sizing: border-box;
    padding: 5px 20px;
    background: #fff;
    &__inner {
      box-sizing: border-box;
      width: 100%;
      height: 150px;
      font-size: 25px;
      padding: 20px;
      background: #f3f4f5;
      border-radius: 4px;
      border: none;
      &:focus {
        border: 1px solid #ff7e33;
        outline: 0;
      }
      &::placeholder {
        color: #c6cad4;
      }
    }
    .error_toast {
      font-size: 14px;
      color: #e64340;
    }
  }

  .kfss-img-uploader {
    padding: 0 20px;
    box-sizing: border-box;
    .kfss-img-list {
      display: flex;
      flex-wrap: wrap;
      .kfss-img-wrapper {
        position: relative;
        width: 160px;
        height: 160px;
        background: #ffffff;
        margin: 0 20px 20px 0;
        border-radius: 8px;
        .kfss-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
        }
        .kfss-delete {
          z-index: 3;
          position: absolute;
          right: 0px;
          top: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: rgba(37, 39, 45, 0.8);
          border-radius: 0 8px 0 8px;
          .kfss-delete-btn {
            font-size: 28px;
            color: #fff;
          }
        }
        .kfss-upload-status {
          z-index: 2;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 4px;
          overflow: hidden;
          .kfss-upload-status-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 55px;
            height: 55px;
            transform: translate(-50%, -50%);
          }
          .kfss-upload-status-error {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ff5b60;
            background: #f3f4f5;
            .kfss-upload-status-error-content {
              font-size: 24px;
            }
          }
        }
        .kfss-add-btn {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
      .kfss-img-upload-btn {
        border: 1px solid #ededef;
      }
    }
  }

  .input {
    padding: 2px 20px;
    box-sizing: border-box;
    background: #fff;
    &__inner {
      .md-field-item-content {
        &::before {
          border-bottom: none;
        }
      }
      .md-input-item-input {
        height: 80px;
        border-radius: 4px;
        padding: 20px;
        font-size: 25px;
        background: #f3f4f5;
        &:focus {
          border: 1px solid #ff7e33;
          outline: 0;
        }
      }
    }
  }

  .submit-button {
    outline: none;
    border: none;
    display: flex;
    margin: 80px auto 0px auto;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    color: #ffffff;
    font-size: 32px;
    font-weight: 500;
    background: #353c57;
    border-radius: 10px;
    &.disabled {
      background: #cccccc;
    }
  }
  .button-disabled {
    background: #e2e4ea;
    color: #fff;
  }
}
</style>
